import { useContext } from 'react';

import { Badge } from '@appkit4/react-components/badge';
import { Button } from '@appkit4/react-components/button';

import { SessionContext } from '@contexts/SessionProvider';

import { generateTimestamp } from '@utils/generateTimestamp';

import styles from './HistoryMessage.module.scss';
import { getProjectFiles } from '@config/getSessionApis';

interface iHistoryMessage {
    author: string;
    version: string;
    message: string;
    createdAt: number;
    chatSessionId: number;
    commitId: string;
    isCurrent: boolean;
    errorStatus: boolean;
}

const HistoryMessage = ({
    author,
    version,
    message,
    createdAt,
    chatSessionId,
    commitId,
    isCurrent,
    errorStatus,
}: iHistoryMessage) => {
    const { designSystem, templateVersion, setCurrentSource, setCurrentHistoryCommit } = useContext(SessionContext);

    const handleRevert = async (event: React.SyntheticEvent) => {
        event.stopPropagation();
        const response: any = await getProjectFiles(chatSessionId, commitId, designSystem, templateVersion); // Wait for the API call to finish
        const projectFiles = response.resultObject;
        const source = {
            payload: {
                files: projectFiles.files,
            },
        };
        setCurrentSource(source);
        setCurrentHistoryCommit(commitId);
    };

    return (
        <div className={styles['history-message']}>
            {isCurrent && <Badge className={styles.badge} value="Current" type="primary-outlined" />}
            <div className={styles['summary-wrapper']}>
                <p className={styles.summary}>
                    <span>{`#${version}`}</span>
                    <span>{` - ${message}`}</span>
                </p>
                {errorStatus ? (
                    <Badge style={{ marginLeft: 16 }} type="danger" value="error" />
                ) : (
                    <Button
                        kind="secondary"
                        icon="icon-revert-outline"
                        aria-label="Design element target button"
                        disabled={isCurrent}
                        onClick={handleRevert}
                    />
                )}
            </div>
            <div className={styles['detail-wrapper']}>
                {generateTimestamp(createdAt)} • {author}
            </div>
        </div>
    );
};

export default HistoryMessage;
